import * as ApiKey from './api-key'
import * as AppBundle from './app-bundle'
import * as AppDefinition from './app-definition'
import * as AppInstallation from './app-installation'
import * as AppUpload from './app-upload'
import * as Asset from './asset'
import * as AssetKey from './asset-key'
import * as ContentType from './content-type'
import * as EditorInterface from './editor-interface'
import * as Entry from './entry'
import * as Environment from './environment'
import * as EnvironmentAlias from './environment-alias'
import * as Extension from './extension'
import * as Http from './http'
import * as Locale from './locale'
import * as Organization from './organization'
import * as OrganizationInvitation from './organization-invitation'
import * as OrganizationMembership from './organization-membership'
import * as PersonalAccessToken from './personal-access-token'
import * as PreviewApiKey from './preview-api-key'
import * as Role from './role'
import * as ScheduledAction from './scheduled-action'
import * as Snapshot from './snapshot'
import * as Space from './space'
import * as SpaceMember from './space-member'
import * as SpaceMembership from './space-membership'
import * as Tag from './tag'
import * as Team from './team'
import * as TeamMembership from './team-membership'
import * as TeamSpaceMembership from './team-space-membership'
import * as Upload from './upload'
import * as Usage from './usage'
import * as User from './user'
import * as Webhook from './webhook'

export default {
  ApiKey,
  AppBundle,
  AppDefinition,
  AppInstallation,
  AppUpload,
  Asset,
  AssetKey,
  ContentType,
  EditorInterface,
  Entry,
  Environment,
  EnvironmentAlias,
  Extension,
  Http,
  Locale,
  Organization,
  OrganizationInvitation,
  OrganizationMembership,
  PersonalAccessToken,
  PreviewApiKey,
  Role,
  ScheduledAction,
  Snapshot,
  Space,
  SpaceMember,
  SpaceMembership,
  Tag,
  Team,
  TeamMembership,
  TeamSpaceMembership,
  Upload,
  Usage,
  User,
  Webhook,
}
